module.exports = __webpack_public_path__ + "static/media/48266322_2309072469167931_9034079054159937536_o.f71d7fa5.jpg";